// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import formatRadioCurveSet from './formatRadioCurveSet'
import { emptyRadioCurveSet } from './initialValues'

const castTheseToString = [
  'bandwidth', // emission bandwidth
  'coChannelTToI',
  'dispersiveFm', // dispersive fade margin
  'downThreshold',
  'emissionDesignator',
  'maxAtpcTrigger',
  'maxRxSignalDbm', // max receive level
  'maxSignatureDepth',
  'maxSignatureWidth',
  'minAtpcTrigger',
  'minDelay',
  'minSignatureDepth',
  'minSignatureWidth',
  'modulationDescription',
  'modulationSchemeId',
  'nonMinDelay',
  'receiverNoiseFigure',
  'rxThreshold', // threshold
  'throughput',
  'txPowerMax',
  'upThreshold',
  'xpif',
]

const formatModulationDataForForm = m => dispatch => {
  const {
    index,
    legacyRadioCode,
    modelNumber,
    radioModulationId,
  } = m

  // since it is not required to assign radio data on a new modulation
  // when we convert this modulation data from API scheme to redux-form scheme,
  // we will supplement unassigned curve data with an empty curve set object
  const radioCurveSet = m.radioCurveSet || emptyRadioCurveSet

  const valuesCastToString = castTheseToString.reduce((a, d) => {
    a[d] = castToString(m[d])
    return a
  }, {})

  return {
    ...dispatch(formatRadioCurveSet(radioCurveSet)),
    ...valuesCastToString,
    index,
    legacyRadioCode,
    modelNumber,
    radioModulationId,
  }
}

export default formatModulationDataForForm
